import { useMutation } from '@tanstack/react-query';

import { queryClient } from '@/adapters/query';
import { usersv2Client } from '@/adapters/schemaClients';
import { USE_CURRENT_USER_QUERY_KEY } from '@/hooks/useCurrentUser';

const invalidateCurrentUserQuery = () => {
  queryClient.invalidateQueries([USE_CURRENT_USER_QUERY_KEY]);
};

export const useMfaActionsQuery = () => {
  const triggerEmailVerificationMutation = useMutation(
    () => usersv2Client.verifyCurrentUserEmailMfa(),
    {
      onSuccess: invalidateCurrentUserQuery
    }
  );

  return {
    invalidate: invalidateCurrentUserQuery,
    mutations: {
      triggerEmailVerification: triggerEmailVerificationMutation
    }
  };
};
